import { http } from "Utils/http";
import { Tab, Row, Col, Card } from "react-bootstrap";
import { useState, useEffect } from "react";
import PSETestBatchInProgress from "Containers/Private/DataSubmission/Component/Test/PSETestBatchInProgress";
import PSETestBatchCompleted from "Containers/Private/DataSubmission/Component/Test/PSETestBatchCompleted";
import FileUpload from "Components/FileUpload/FileUpload";

import PSETestBatchDeleted from "Containers/Private/DataSubmission/Component/Test/PSETestBatchDeleted";
import { Nav } from "react-bootstrap";

const TabDatatable = () => {

  const [tab, setTab] = useState('inProgress');
  const [fileUploadMsg, setFileUploadMsg] = useState([]);
  const [progress, setProgress] = useState();

  const dataTableTabActive = {
    'color': 'white',
    'backgroundColor': '#1d6193'
  };

  // set num of file 
  const numOfFile = 2;
  // set file type
  const fileFormat = ".csv, .txt, .zip, .rar, .7z, .gz";
  // set file upload ajax call
  const submitFile = async (formData) => {
    //console.log("submit file");
    const res = await http.post('/api/cda/dataSubmission', formData, {
      headers: {
        //"Content-Type": "multipart/form-data"
      },
      onUploadProgress: data => {
        //Set the progress value to show the progress bar
        setProgress(Math.round((100 * data.loaded) / data.total))
      },
    }).catch(function (error) {
      //console.log("error caught from the file upload");
      if (!showPopup) {
        setShowPopup(true);
        setPopMsg({
          title: "Data Error",
          msg: "At this time, we are experiencing problems retrieving the data."
        });
      }
    });

    return res;
  }
  // fileUpload output message
  const fileUploadOutputMsg = (msg) => {
    //console.log("print out fileUploadOutputMsg", msg);
    setFileUploadMsg(msg);
  }

  // Date format: mm/dd/yyyy hh: mm
  const handleDateFormat = (time) => {
    let date = new Date(time);
    let year = date.getFullYear();
    let month = date.getMonth() + 1;
    let day = date.getDate();
    let hour = date.getHours();
    let min = date.getMinutes();
    return (
      <div>
        {month < 10 ? "0" + month : month}/
        {day < 10 ? "0" + day : day}/
        {year + " "}
        {hour < 10 ? "0" + hour : hour}:
        {min < 10 ? "0" + min : min}
      </div>
    )
  }

  // Popup
  const [showPopup, setShowPopup] = useState(false);
  const [popupMsg, setPopMsg] = useState({
    title: "",
    msg: ""
  })
  const handlePopup = (flag) => {
    setShowPopup(flag);
  }

  return (
    <>
      <Row>
        <h2 className="text-start">CDA Test Data Submission</h2>
        <p className="text-start">To submit test data, enter the required information below. The uploaded file name extensions should be in .xml or .zip format</p>
      </Row>
      <br />
      <Row>
        <h3 className="text-start">Test Data Submission</h3>
      </Row>
      <hr />

      {/* <Row>
        <Col>
          {
            fileUploadMsg.length !== 0 ?
              fileUploadMsg.map((m, index) =>
                <Alert key={index} variant={'danger'} style={{ textAlign: 'left' }}>
                  <FontAwesomeIcon icon={faExclamationTriangle} />&nbsp;&nbsp;&nbsp;{m}
                </Alert>
              ) : null
          }
        </Col>
        <Col></Col>
      </Row> */}
      <FileUpload
        isTestSubmission={"Y"}
        submitFile={submitFile}
        numOfFile={numOfFile}
        fileFormat={fileFormat}
        outputMsg={fileUploadOutputMsg}
        progress={progress}
      />
      <br />
      <br />
      {/* <Tabs
        id="controlled-tab"
        activeKey={tab}
        onSelect={(k) => setTab(k)}
        className="mb-3"
      >
        <Tab eventKey="inProgress" title={<span className="dataTableTab">In-Process Submissions</span>}>
          {tab === "inProgress" ? <PSETestBatchInProgress /> : ""}
        </Tab>
        <Tab eventKey="completed" title={<span className="dataTableTab">Processed Submissions</span>}>
          {tab === "completed" ? <PSETestBatchCompleted /> : ""}
        </Tab>
        <Tab eventKey="deleted" title={<span className="dataTableTab">Deleted Submissions</span>}>
          {tab === "deleted" ? <PSETestBatchDeleted /> : ""}
        </Tab>
      </Tabs> */}

      <Row>
        <h3 className="text-start">Test Data Submission Tables</h3>
      </Row>
      <hr />
      <Row>
        <p className="text-start">Click on the tabs below to view each of the test data submission tables</p>
      </Row>
      <br />
      <br />
      <Tab.Container id="pseTestBatchTabs" activeKey={tab}
        onSelect={(k) => setTab(k)}
      >
        <Nav className="">
          <Nav.Item>
            <Nav.Link eventKey="inProgress" style={tab === "inProgress" ? dataTableTabActive : {}} className="dataTableTab">In-Process Submissions</Nav.Link>
          </Nav.Item>
          <Nav.Item>
            <Nav.Link eventKey="completed" style={tab === "completed" ? dataTableTabActive : {}} className="dataTableTab">Processed Submissions</Nav.Link>
          </Nav.Item>
          <Nav.Item>
            <Nav.Link eventKey="deleted" style={tab === "deleted" ? dataTableTabActive : {}} className="dataTableTab">Deleted Submissions</Nav.Link>
          </Nav.Item>
        </Nav>
        <Row>
          <Tab.Content>
            <Card>
              <Tab.Pane eventKey="inProgress">
                {tab === "inProgress" ? <PSETestBatchInProgress /> : ""}
              </Tab.Pane>
              <Tab.Pane eventKey="completed">
                {tab === "completed" ? <PSETestBatchCompleted /> : ""}
              </Tab.Pane>
              <Tab.Pane eventKey="deleted">
                {tab === "deleted" ? <PSETestBatchDeleted /> : ""}
              </Tab.Pane>
            </Card>
          </Tab.Content>
        </Row>
      </Tab.Container >
    </>
  )
}

export default TabDatatable;